import { jsx as _jsx } from "react/jsx-runtime";
const BannerIcon = ({ icon }) => {
    /**
     * Align icon with title line height = mt-1
     * Size = 24px - this fix visual bug when icon is an font
     */
    return _jsx("div", { className: "mt-1 flex size-6 justify-center", children: icon });
};
export default BannerIcon;
